import React, { useEffect, useRef, useState } from "react";
import { color } from "../../../StyleData/Config";
import {
  Grid,
  Typography,
  Paper,
  Select,
  MenuItem,
  TextField,
  Box,
  Divider,
  IconButton,
  Tab,
  FormControlLabel,
  Radio,
  Checkbox,
  Button,
  Autocomplete,
  createFilterOptions,
  CircularProgress,
  Switch,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { axiosPrivate, siteInfo } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";
import { Add, DeleteOutline, OfflineShareTwoTone, PlaylistAdd, Sort, UploadFileRounded } from "@mui/icons-material";
import { fromUTC, getCurrentInTimeZone, getDateWithOutUTC, toUTC } from "../../../utils/dateUtil";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ErrorProps from "../../../Component/Errorprops";
import { defaultInfo, generationType, isSystemAccess } from "../../../ConfigInfo/Info";
import { filterNoneOptions } from "../../../Component/filters";
import NormalTable from "../../../Component/NormalTable";
import ResponsiveDialog from "../../../Component/ResponsiveDialog";
import DocUpload from "../../../Component/DocUpload";
import { toast } from "react-toastify";

const CreatePM = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const edit = useSelector((state) => state.editData.pmEditData.edit);
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);
  const isSystem = isSystemAccess(siteInfoDetail);

  const editData = useSelector((state) => state.editData.pmEditData.data);

  const [conditionMeterLoading,setConditionMeterLoading] = useState(false);
  const [meterLoading, setMeterLoading] = useState(false);
  const [locationId, setLocationId] = useState([]);
  const [systemId, setSystemId] = useState([]);
  const [assetId, setAssetId] = useState([]);
  const [PMStatus, setPMStatus] = useState([]);
  // const [siteId, setSiteId] = useState([]);
  const [jobPlan, setJobPlan] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [pmJobType, setPmJobType] = useState([]);
  const [frequnittime, setFrequnittime] = useState([]);
  const [frequnitmeter, setFrequnitmeter] = useState([]);
  const [meter, setMeter] = useState([]);
  const [gaugeMeters, setGaugeMeters] = useState([]);
  const [conditionGivenAs, setConditionGivenAs] = useState([]);
  const [gaugeMeterRangeValue,setGaugeMeterRangeValue] = useState(0);
  const [dateValue, setDateValue] = useState({
    earliestStartDate: edit
      ? editData.pmTimeBasedScheduler !== undefined
        ? editData.pmTimeBasedScheduler.earliestStartDate
        : null
      : null,
    latestEndDate: edit
      ? editData.pmTimeBasedScheduler !== undefined
        ? editData.pmTimeBasedScheduler.latestEndDate
        : null
      : null,
  });

  const [value, setValue] = useState("1");
  const [docDialogOpen, setDocDialogOpen] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    message: "",
    onConfirm: null,
  });

  const [priority, setPriority] = useState([]);
  const [defaultValueField, setDefaultValueField] = useState({
    priority: "",
    jobType: "",
  });
  const [defaultPri, setDefaultPri] = useState("");
  const [loading, setLoading] = useState(false);
  const [scheduleType, setScheduleType] = useState([]);
  const [aCValue, setACValue] = useState({
    jobplan: edit ? editData.jobPlanName : "",
  });
  const [assetInfo, setAssetInfo] = useState({});
  const [meterData, setMeterData] = useState([]);
  const formikRef = useRef();
  useEffect(() => {
    if (formikRef.current) {
      const formikCurrent = formikRef.current;
      formikCurrent.setFieldValue(
        "priorityId",
        formikCurrent.values.priorityId === "" ? defaultValueField.priority : formikCurrent.values.priorityId,
      );
      formikCurrent.setFieldValue(
        "workTypeId",
        formikCurrent.values.workTypeId === "" ? defaultValueField.jobType : formikCurrent.values.workTypeId,
      );
    }
  }, [defaultValueField]);
  const [workCenters, setWorkCenters] = useState([]);
  useEffect(() => {
    const loadInitialData = async () => {
      await getData();
      if (edit && editData.generationType) {
        await getGenerationData(editData.generationType);
      }
    };
    loadInitialData();
    getMeterData(editData.assetId);
    axiosPrivate
      .get("/selectlist/getallworkcenters")
      .then((res) => {
        setWorkCenters(res.data || []);
      })
      .catch(() => setWorkCenters([]));
  }, []);

  const getGenerationData = async (selectedGenerationType) => {
    setLoading(true);
    setLocationId([]);
    setSystemId([]);
    setAssetId([]);

    if (selectedGenerationType === generationType.ASSET || selectedGenerationType === generationType.LOCATION) {
      const locationLink = masterAPI["location"].link;
      try {
        const res = await axiosPrivate.get(`${locationLink}`);
        setLocationId(res.data.result);
      } catch (e) {
        setLocationId([]);
        console.log(e, "createpm locaion getall");
      }
    }

    if (
      isSystem &&
      (selectedGenerationType === generationType.ASSET || selectedGenerationType === generationType.SYSTEM)
    ) {
      const systemLink = masterAPI["system"].link;
      try {
        const res = await axiosPrivate.get(`${systemLink}`);
        setSystemId(res.data.result.filter((fil) => fil.isActive));
      } catch (e) {
        setSystemId([]);
        console.log(e, "createpm system getall");
      }
    }

    if (selectedGenerationType === generationType.ASSET) {
      const assetLink = masterAPI["assets"].link;
      try {
        const res = await axiosPrivate.get(`${assetLink}`);
        const filterData = res.data.result.filter(
          (item) => item.statusName !== "Decomissioned" && item.statusName !== "Missing",
        );
        console.log("Asset", filterData);
        setAssetId(filterData);
      } catch (e) {
        setAssetId([]);
        console.log(e, "createpm asset getall");
      }
    }

    setLoading(false);
  };

  const getData = async () => {
    setLoading(true);
    //   const siteLink = masterAPI["site"].link;
    //  await axiosPrivate
    //     .get(`${siteLink}`)
    //     .then((res) => {
    //       console.log(res.data.result);
    //       setSiteId(res.data.result);
    //     })
    //     .catch((e) => {
    //       setSiteId([])
    //       console.log(e, "createpm site getall");
    //     });

    const pmStatusLink = masterAPI["selectList"].pmStatus;
    await axiosPrivate
      .get(`${pmStatusLink}`)
      .then((res) => {
        console.log(res.data);
        setPMStatus(res.data);
      })
      .catch((e) => {
        setPMStatus([]);
        console.log(e, "getpmStatus Create pm");
      });

    const jobplanLink = masterAPI["jobPlan"].link;
    await axiosPrivate
      .get(`${jobplanLink}`)
      .then((res) => {
        console.log(res.data.result);
        setJobPlan(res.data.result);
      })
      .catch((e) => {
        setJobPlan([]);
        console.log(e, "getJobPlan Create pm");
      });

    const getjobType = masterAPI["selectList"].workordertype;
    await axiosPrivate
      .get(`${getjobType}?WorktypeforPM=${true}`)
      .then((res) => {
        console.log(res.data, "test");
        const filterPm = res.data.filter(
          (fil) => fil.text.split("-")[0].trim() + "-" + fil.text.split("-")[1].trim() !== defaultInfo.workType.PM_INS,
        );
        setDefaultValueField({
          ...defaultValueField,
          jobType: filterPm[0].value,
        });
        setJobType(filterPm);
      })
      .catch((e) => {
        setJobType([]);
        console.log(e, "jobtype Create pm");
      });

    // const getPmJobType = masterAPI["selectList"].pmJobType;
    // await axiosPrivate
    //   .get(`${getPmJobType}`)
    //   .then((res) => {
    //     console.log(res.data);
    //     setPmJobType(res.data);
    //   })
    //   .catch((e) => {
    //     setPmJobType([]);
    //     console.log(e, "pmjobtype Create pm");
    //   });

    const getFreqTime = masterAPI["selectList"].frequencyunitsfortime;

    await axiosPrivate
      .get(`${getFreqTime}`)
      .then((res) => {
        console.log(res.data);
        const filterData = res.data.filter((item) => item.value !== "None");
        setFrequnittime(filterData);
      })
      .catch((e) => {
        setFrequnittime([]);
        console.log(e, "freq unit time Create pm");
      });

    const getFreqMeter = masterAPI["selectList"].frequencyunitsformeter;

    await axiosPrivate
      .get(`${getFreqMeter}`)
      .then((res) => {
        console.log(res.data);
        setFrequnitmeter(res.data);
      })
      .catch((e) => {
        setFrequnitmeter([]);
        console.log(e, "freq unit meter Create pm");
      });

      const getConditionLevellink=masterAPI.selectList.getConditionGivenAs
      await axiosPrivate
      .get(`${getConditionLevellink}`)
      .then((res) => {
        console.log(res.data);
        setConditionGivenAs(res.data);
      })
      .catch((e) => {
        setConditionGivenAs([]);
        console.log(e, "freq unit meter Create pm");
      });
       

    // const meter = masterAPI["meter"].link;

    // await axiosPrivate
    //   .get(`${meter}`)
    //   .then((res) => {
    //     console.log(res.data.result);
    //     setMeter(res.data.result);
    //   })
    //   .catch((e) => {
    //     setMeter([]);
    //     console.log(e, " meter Create pm");
    //   });

    //////////////////priority////////////////////////////////////////
    const priLink = masterAPI["priority"].link;
    await axiosPrivate
      .get(`${priLink}`)
      .then((res) => {
        console.log(res.data.result, "prodd");
        setDefaultValueField({
          ...defaultValueField,
          priority: res.data.result[0].id,
        });
        setPriority(res.data.result);
      })
      .catch((e) => {
        setPriority([]);
        console.log(e, "Priority Create Wo");
      });
    ///////////////////pm Schedule Type/////////////////
    const scheduleLink = masterAPI["selectList"].pmScheduleType;
    await axiosPrivate
      .get(`${scheduleLink}`)
      .then((res) => {
        console.log(res);
        const filterNone = res.data.filter((item) => item.value !== "None");
        setScheduleType(filterNone);
      })
      .catch((e) => {
        setScheduleType([]);
        console.log(e, "error pm schedule type");
      });
      if(edit && editData.scheduleType==="Meter"&&editData.assetId){
        getMeterData(editData.assetId);
      }
      if(edit && editData.scheduleType==="Condition"&&editData.assetId){
        getGaugeMeterByAsset(editData.assetId);
      }
    setLoading(false);
  };
  const getMeterData = async (id) => {
    setMeterLoading(true);
    const meterLink = masterAPI["meter"].getMeterByAsset;
    await axiosPrivate
      .get(`${meterLink}/${id}`)
      .then((res) => {
        console.log("Meter Data", res.data.result);
        setMeterData(res.data.result);
      })
      .catch((e) => {
        setMeterData([]);
        console.log(e, "meterSide Menu");
      })
      .finally(() => {
        setMeterLoading(false);
      });
  };

  const handleCancel = () => {
    navigate("/pm");
  };

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };
  console.log("editData", editData);
  const initialValue = {
    description: edit ? editData.description : "",
    name: edit ? editData.name : "",
    generationType: edit ? (editData.generationType ?? "") : "",
    locationId: edit ? editData.locationId : null,
    systemId: isSystem && edit ? editData.systemId : null,
    assetId: edit ? editData.assetId : null,

    status: edit ? editData.status : "NEW",
    priorityId: edit ? editData.priority?.id : "",
    siteId: siteInfoDetail.siteId,
    jobPlanId: edit ? editData.jobPlanId : null,
    jobplanNameText: "",
    workTypeId: edit ? editData.workTypeId : "",
    // jobType: edit ? editData.jobType : "",
    pmType: edit ? editData.pmType : "fixed",
    scheduleType: edit ? editData.scheduleType : "Time",
    isOffsetDays: edit ? (editData.isOffsetDays ?? false) : false,
    workCenterId: edit ? editData.workCenterId : "",
    documents: edit ? editData.documents || [] : [],
    pmMeterBasedScheduler: {
      meterId: edit
        ? editData.pmMeterBasedScheduler !== undefined
          ? editData.pmMeterBasedScheduler?.meterId
          : null
        : null,
      frequency: edit
        ? editData.pmMeterBasedScheduler !== undefined
          ? editData.pmMeterBasedScheduler?.frequency
          : 0
        : 0,
      startAtValue: edit
        ? editData.pmMeterBasedScheduler !== undefined
          ? editData.pmMeterBasedScheduler?.startAtValue
          : 0
        : 0,
      earliestTriggerValue: edit
        ? editData.pmMeterBasedScheduler !== undefined
          ? editData.pmMeterBasedScheduler?.earliestTriggerValue
          : 0
        : 0,
      currentReading: edit
        ? editData.pmMeterBasedScheduler !== undefined
          ? editData.pmMeterBasedScheduler?.currentReading
          : 0
        : 0,
      frequencyUnitForMeter: edit
        ? editData.pmMeterBasedScheduler !== undefined
          ? editData.pmMeterBasedScheduler?.frequencyUnitForMeter
          : 0
        : null,
      triggertype: edit
        ? editData.pmMeterBasedScheduler !== undefined
          ? editData.pmMeterBasedScheduler?.triggertype
          : "Continuous"
        : "Continuous",
      meterBaseScheduleEndByValue: edit
        ? editData.pmMeterBasedScheduler !== undefined
          ? editData.pmMeterBasedScheduler?.meterBaseScheduleEndByValue
          : 0
        : 0,
    },

    pmTimeBasedScheduler: {
      frequency: edit
        ? editData.pmTimeBasedScheduler !== undefined
          ? editData.pmTimeBasedScheduler?.frequency
          : 0
        : 0,
      frequencyUnitForTime: edit
        ? editData.pmTimeBasedScheduler !== undefined
          ? editData.pmTimeBasedScheduler?.frequencyUnitForTime
          : null
        : null,
      nextDueDate: edit
        ? editData.pmTimeBasedScheduler !== undefined
          ? fromUTC(editData.pmTimeBasedScheduler?.nextDueDate).dayjsObject
          : getCurrentInTimeZone().dayjsObject.startOf("day")
        : getCurrentInTimeZone().dayjsObject.startOf("day"),
      targetEndDate: edit
        ? editData.pmTimeBasedScheduler !== undefined
          ? fromUTC(editData.pmTimeBasedScheduler?.targetEndDate).dayjsObject
          : getCurrentInTimeZone().dayjsObject.endOf("day")
        : getCurrentInTimeZone().dayjsObject.endOf("day"),
      offsetDays: edit
        ? editData.pmTimeBasedScheduler !== undefined
          ? editData.pmTimeBasedScheduler?.offsetDays
          : "0"
        : "0",
      targetDay: edit
        ? editData.pmTimeBasedScheduler !== undefined
          ? editData.pmTimeBasedScheduler?.targetDay
          : "1"
        : "1",
      timeBaseScheduleEndBy: edit
        ? editData.pmTimeBasedScheduler !== undefined
          ? fromUTC(editData.pmTimeBasedScheduler.timeBaseScheduleEndBy).dayjsObject
          : getCurrentInTimeZone().dayjsObject.startOf("day")
        : null,
    },
    pmConditionScheduler:{
    meterId: edit ? editData.pmConditionScheduler?.meterId : null,
    levelIsGivenAs: edit ? editData.pmConditionScheduler?.levelIsGivenAs : null,
    resetMeterWhenWorkOrderIsRaised: edit ? editData.pmConditionScheduler?.resetMeterWhenWorkOrderIsRaised : true,
    resetTo: edit ? editData.pmConditionScheduler?.resetTo : 0,
    targetDay: edit ? editData.pmConditionScheduler?.targetDay:1,
    conditionBaseScheduleEndBy : edit ? editData.pmConditionScheduler?.conditionBaseScheduleEndBy : null  
    }
  };

  const onSubmit = async (values) => {
    console.log(values);
    console.log(priority[0].id);
    setLoading(true);
    let postData = {
      description: values.description,
      name: values.name === "" ? values.jobplanNameText : values.name,
      generationType: values.generationType,
      locationId: values.locationId,
      systemId: isSystem ? values.systemId : null,
      assetId: values.assetId,
      status: values.status,
      // priorityId: values.priorityId === "" ? priority[0].id : values.priorityId,
      priorityId: values.priorityId,
      siteId: values.siteId,
      jobPlanId: values.jobPlanId,
      workTypeId: values.workTypeId,
      // jobType: values.jobType,
      pmType: values.pmType,
      scheduleType: values.scheduleType,
      isOffsetDays: values.isOffsetDays,
      workCenterId: values.workCenterId,
    };
    if (!edit) {
      postData = {
        ...postData,
        documents: values.documents,
      };
    }
    if (values.scheduleType.toUpperCase() === "TIME" || values.scheduleType.toUpperCase() === "MIXED") {
      postData = {
        ...postData,
        pmTimeBasedScheduler: {
          frequency: values.pmTimeBasedScheduler.frequency,
          frequencyUnitForTime: values.pmTimeBasedScheduler.frequencyUnitForTime,
          nextDueDate: toUTC(values.pmTimeBasedScheduler.nextDueDate).utcISOString,
          targetEndDate: toUTC(values.pmTimeBasedScheduler.targetEndDate).utcISOString,
          offsetDays: values.pmTimeBasedScheduler.offsetDays,
          targetDay: values.pmTimeBasedScheduler.targetDay,
          timeBaseScheduleEndBy: values.pmTimeBasedScheduler.timeBaseScheduleEndBy
            ? toUTC(values.pmTimeBasedScheduler.timeBaseScheduleEndBy).utcISOString
            : null,
        },
      };
    }
    if (values.scheduleType.toUpperCase() === "METER" || values.scheduleType.toUpperCase() === "MIXED") {
      postData = {
        ...postData,
        pmMeterBasedScheduler: {
          meterId: values.pmMeterBasedScheduler.meterId,
          frequency: values.pmMeterBasedScheduler.frequency,
          startAtValue: values.pmMeterBasedScheduler.startAtValue,
          earliestTriggerValue: values.pmMeterBasedScheduler.earliestTriggerValue,
          currentReading: values.pmMeterBasedScheduler.currentReading,
          frequencyUnitForMeter: "None",
          // values.pmMeterBasedScheduler.frequencyUnitForMeter,
          triggertype: values.pmMeterBasedScheduler.triggertype,
          meterBaseScheduleEndByValue: values.pmMeterBasedScheduler.meterBaseScheduleEndByValue,
        },
      };
    }
    if (values.scheduleType.toUpperCase() === "CONDITION") {
      postData = {
        ...postData,
        pmConditionScheduler: {
          meterId: values.pmConditionScheduler.meterId,
          levelIsGivenAs: values.pmConditionScheduler.levelIsGivenAs,
          resetMeterWhenWorkOrderIsRaised: values.pmConditionScheduler.resetMeterWhenWorkOrderIsRaised,
          resetTo: values.pmConditionScheduler.resetTo,
          targetDay: values.pmConditionScheduler.targetDay,
          conditionBaseScheduleEndBy: values.pmConditionScheduler.conditionBaseScheduleEndBy? 
          toUTC(values.pmConditionScheduler.conditionBaseScheduleEndBy).utcISOString: null,
        },
      };
    }
    console.log("postData", postData);

    const pmcreate = masterAPI["PM"].create;
    const pmUpdate = masterAPI["PM"].update;
    if (edit) {
      const putData = {
        id: editData.id,
        ...postData,
      };
      await axiosPrivate
        .put(`${pmUpdate}`, putData)
        .then((res) => {
          console.log(res);
          navigate("/pm");
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "pm update error");
        });
    } else {
      await axiosPrivate
        .post(`${pmcreate}`, postData)
        .then((res) => {
          console.log(res, "pm create");
          navigate("/pm");
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "pm create error");
        });
    }
  };

  // const handleCheckBox = (e, type) => {
  //   if (e.target.checked) {
  //     setChecked({ ...checked, [type]: true });
  //   } else {
  //     setChecked({ ...checked, [type]: false });
  //   }
  // };
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const openConfirmDialog = (message, onConfirm) => {
    setConfirmDialog({ open: true, message, onConfirm });
  };

  const clearScheduleData = (selectedScheduleType, setFieldValue) => {
    if (["METER", "MIXED"].includes(selectedScheduleType)) {
      setFieldValue("pmMeterBasedScheduler.meterId", "");
      setFieldValue("pmMeterBasedScheduler.frequency", 0);
      setFieldValue("pmMeterBasedScheduler.startAtValue", 0);
      setFieldValue("pmMeterBasedScheduler.earliestTriggerValue", 0);
      setFieldValue("pmMeterBasedScheduler.currentReading", 0);
      setFieldValue("pmMeterBasedScheduler.frequencyUnitForMeter", "");
      setFieldValue("pmMeterBasedScheduler.triggertype", "Continuous");
      setFieldValue("pmMeterBasedScheduler.meterBaseScheduleEndByValue", 0);
    }

    if (selectedScheduleType === "MIXED") {
      setFieldValue("pmTimeBasedScheduler.frequency", 0);
      setFieldValue("pmTimeBasedScheduler.frequencyUnitForTime", "");
      setFieldValue("pmTimeBasedScheduler.nextDueDate", getCurrentInTimeZone().dayjsObject.startOf("day"));
      setFieldValue("pmTimeBasedScheduler.targetEndDate", getCurrentInTimeZone().dayjsObject.endOf("day"));
      setFieldValue("pmTimeBasedScheduler.offsetDays", "0");
      setFieldValue("pmTimeBasedScheduler.targetDay", "1");
      setFieldValue("pmTimeBasedScheduler.timeBaseScheduleEndBy", null);
      setFieldValue("isOffsetDays", false);
      setDateValue({ earliestStartDate: null, latestEndDate: null });
    }

    if (selectedScheduleType === "CONDITION") {
      setFieldValue("pmConditionScheduler.meterId", null);
      setFieldValue("pmConditionScheduler.levelIsGivenAs", null);
      setFieldValue("pmConditionScheduler.resetMeterWhenWorkOrderIsRaised", true);
      setFieldValue("pmConditionScheduler.resetTo", 0);
      setFieldValue("pmConditionScheduler.targetDay", 1);
      setFieldValue("pmConditionScheduler.conditionBaseScheduleEndBy", null);
    }

    setFieldValue("scheduleType", "Time");
  };

  const applyGenerationType = (selectedType, values, setFieldValue) => {
    setFieldValue("generationType", selectedType);
    setFieldValue("assetId", selectedType === generationType.ASSET ? values.assetId : null);
    setFieldValue("locationId", selectedType === generationType.LOCATION ? values.locationId : null);
    setFieldValue("systemId", selectedType === generationType.SYSTEM ? values.systemId : null);
    setAssetInfo({});
    getGenerationData(selectedType);
  };

  const validationSchema = Yup.object().shape({
    generationType: Yup.string().required("Generation Type is required"),
    locationId: Yup.string().when("generationType", {
      is: generationType.LOCATION,
      then: (schema) => schema.required("Location is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    systemId: Yup.string().when("generationType", {
      is: (selectedType) => isSystem && selectedType === generationType.SYSTEM,
      then: (schema) => schema.required("System is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    assetId: Yup.string().when("generationType", {
      is: generationType.ASSET,
      then: (schema) => schema.required("Asset is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    priorityId: Yup.string().required("This field is required"),
    jobPlanId: Yup.string().required("This field is required"),
    workCenterId: Yup.string().required("This field is required"),
    //  workTypeId:Yup.string().required("Work Type is required"),
    pmTimeBasedScheduler: Yup.object().shape({
      frequency: Yup.number().when("$scheduleType", {
        is: (val) => ["TIME", "MIXED"].includes(val.toUpperCase()),
        then: (schema) => schema.min(1, "Value must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
      //   frequency: Yup.number().when("scheduleType", {
      // is: (val) => val === "Time"||val === "Mixed",
      // then: (schema) => schema.required("This is required").min(1, "Value must be greater than 0"),
      // otherwise: (schema) => schema.notRequired(),
      // }),
      frequencyUnitForTime: Yup.string().when("$scheduleType", {
        is: (val) => ["TIME", "MIXED"].includes(val.toUpperCase()),
        then: (schema) => schema.required("This is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      timeBaseScheduleEndBy: Yup.date().when("$scheduleType", {
        is: (val) => ["TIME", "MIXED"].includes(val.toUpperCase()),
        then: (schema) => schema.required("This is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    pmMeterBasedScheduler: Yup.object().shape({
      frequency: Yup.number().when("$scheduleType", {
        is: (val) => ["METER", "MIXED"].includes(val.toUpperCase()),
        then: (schema) => schema.min(1, "Value must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
      meterId: Yup.string().when("$scheduleType", {
        is: (val) => ["METER", "MIXED"].includes(val.toUpperCase()),
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      // frequencyUnitForMeter: Yup.string().when("$scheduleType", {
      //   is: (val) => ["METER", "MIXED"].includes(val.toUpperCase()),
      //   then: (schema) => schema.required("This field is required"),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      startAtValue: Yup.number().when("$scheduleType", {
        is: (val) => ["METER", "MIXED"].includes(val.toUpperCase()),
        then: (schema) => schema.min(1, "Value must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
      meterBaseScheduleEndByValue: Yup.number().when("$scheduleType", {
        is: (val) => ["METER", "MIXED"].includes(val.toUpperCase()),
        then: (schema) => schema.min(1, "Value must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    pmConditionScheduler: Yup.object().shape({
       meterId: Yup.string().when("$scheduleType", {
        is: (val) => ["CONDITION"].includes(val.toUpperCase()),
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      levelIsGivenAs: Yup.string().when("$scheduleType", {
        is: (val) => ["CONDITION"].includes(val.toUpperCase()),
        then: (schema) => schema.required("This is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      resetTo: Yup.number().when(["$scheduleType", "raised"], {
        is: (scheduleType, raised) => scheduleType?.toUpperCase() === "CONDITION" && raised === true,
        then: (schema) => schema.min(1, "This field is required").required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      targetDay: Yup.number().when("$scheduleType", {
        is: (val) => ["CONDITION"].includes(val.toUpperCase()),
        then: (schema) => schema.min(1, "Value must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
       conditionBaseScheduleEndBy: Yup.date().when("$scheduleType", {
        is: (val) => ["CONDITION"].includes(val.toUpperCase()),
        then: (schema) => schema.required("This is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      }),
  
  });

  const getGaugeMeterByAsset = async (assetId) => {
    setConditionMeterLoading(true);
    try {
      const getGaugementerAPI = masterAPI.meter.getGaugeMeterByAsset;
      const response = await axiosPrivate.get(`${getGaugementerAPI}/${assetId}`);
      if (response.data.result.length > 0) {
        setGaugeMeters(response.data.result);
      } else {
        setGaugeMeters([]);
      }
    } catch (error) {
      setGaugeMeters([]);
      console.error("Error fetching gauge meters:", error);
    } finally {
      setConditionMeterLoading(false);
    }
  };

  return (
    <Box sx={{ p: 1 }}>
      <Box
        // sx={{
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "space-between",
        //   width: "100%",
        // }}
        sx={{ mb: "1rem" }}
      >
        <Typography
          sx={{
            // color: color.masterDialogTitleColor,
            // fontSize: color.masterDialogFontSize,
            fontSize: color.AssetTitlesize,
            fontWeight: color.sideFontWeightAsset,
          }}
        >
          {edit ? `${editData.code + " - " + editData.name}` : " New PM Schedule"}
        </Typography>
      </Box>
      <Formik innerRef={formikRef} initialValues={initialValue} onSubmit={onSubmit} validationSchema={validationSchema}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <TabContext value={value}>
              <Box
                sx={{
                  ".css-hg18dx-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                    color: color.TabLabelcolor,
                    // p: 0.5,
                  },
                  display: "flex",
                  justifyContent: "space-between",
                  // width: "98%",
                }}
              >
                <TabList
                  onChange={handleChangeTab}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    sx: { backgroundColor: color.TabLabelcolor, height: "3px" },
                  }}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label="General" value="1" sx={{ textTransform: "none" }} />
                  <Tab label="Scheduling" value="2" sx={{ textTransform: "none" }} />
                  {!edit && <Tab label="Doc" value="3" sx={{ textTransform: "none" }} />}
                </TabList>

                {/* <IconButton type='submit' sx={{backgroundColor:color.TableButtonColor}}>
          <PlaylistAdd sx={{color:"white",fontSize:"1.7rem"}}/>
        </IconButton> */}
              </Box>
              <Box sx={{ mt: "1rem" }}>
                <TabPanel value="1" sx={{ p: 1 }}>
                  {/* <CreateGeneral jobPlanIden={handleJobPlanId}/> */}
                  <Grid
                    container
                    sx={{
                      boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                      p: 1.5,
                      backgroundColor: "white",
                    }}
                  >
                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          color: color.masterDialogTitleColor,
                          fontSize: color.masterDialogFontSize,
                          fontWeight: color.sideWeightFont,
                          mb: "10px",
                        }}
                      >
                        Details
                      </Typography>
                      <Divider
                        sx={{
                          border: "1px solid rgb(0 0 0 / 17%)",
                          mb: "15px",
                        }}
                      />
                    </Grid>
                    <Grid container item xs={12} spacing={"1rem"}>
                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Name
                        </Typography>
                        <Field
                          as={TextField}
                          size={"small"}
                          type="text"
                          name="name"
                          placeholder="Enter name"
                          fullWidth
                          sx={{
                            ".MuiInputBase-input": {
                              // letterSpacing: "0.2rem",

                              "&::placeholder": {
                                // color: "green",
                                opacity: 1,
                                color: color.placeholderColor,
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          PM Description
                        </Typography>
                        <Field
                          as={TextField}
                          size={"small"}
                          type="text"
                          name="description"
                          placeholder="Enter Description"
                          fullWidth
                          sx={{
                            ".MuiInputBase-input": {
                              // letterSpacing: "0.2rem",

                              "&::placeholder": {
                                // color: "green",
                                opacity: 1,
                                color: color.placeholderColor,
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Generation Type *
                        </Typography>
                        <Field
                          as={Select}
                          name="generationType"
                          required
                          size="small"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.generationType !== ""
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                          onChange={(event) => {
                            const selectedType = event.target.value;
                            const selectedScheduleType = (values.scheduleType || "").toUpperCase();
                            const hasIncompatibleSchedule =
                              [generationType.LOCATION, generationType.SYSTEM].includes(selectedType) &&
                              ["METER", "MIXED", "CONDITION"].includes(selectedScheduleType);

                            if (hasIncompatibleSchedule) {
                              const scheduleLabel = selectedScheduleType === "METER" ? "Meter" : selectedScheduleType === "MIXED" ? "Mixed" : "Condition";
                              openConfirmDialog(
                                `You currently have a ${scheduleLabel} schedule. ${scheduleLabel} schedules are not available for ${selectedType} generation. 
                                Do you want to change the generation type, clear the ${scheduleLabel} schedule data, and change the schedule type to Time?`,
                                () => {
                                  clearScheduleData(selectedScheduleType, setFieldValue);
                                  applyGenerationType(selectedType, values, setFieldValue);
                                },
                              );
                              return;
                            }

                            applyGenerationType(selectedType, values, setFieldValue);
                          }}
                        >
                          {Object.values(generationType)
                            .filter((type) => isSystem || type !== generationType.SYSTEM)
                            .map((type) => (
                              <MenuItem key={type} value={type}>
                                {type}
                              </MenuItem>
                            ))}
                        </Field>
                        <ErrorMessage name="generationType">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Asset
                        </Typography>
                        {/* <Field
                as={Select}
                // label={"Select"}
                size={"small"}
                type="text"
                name="assetId"
               
                fullWidth
                displayEmpty
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
               renderValue={values.assetId !== null ? undefined : () =><Typography sx={{  color: color.placeholderColor,
                fontSize: "13px",}} >Select</Typography> }
              >
                
                {assetId.map((id, i) => (
                  <MenuItem key={i} value={id.id}>{id.assetName}</MenuItem>
                ))}
              </Field> */}
                        <Field
                          name="assetId"
                          disabled={values.generationType !== generationType.ASSET}
                          value={assetId.find((a) => a.id === values.assetId) || null}
                          component={Autocomplete}
                          filterOptions={filterOptions}
                          options={assetId}
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) => (option ? option.code + " - " + option.assetName : "")}
                          onChange={(event, value) => {
                            if (value !== null) {
                              // console.log(value);
                              setFieldValue("assetId", value.id);
                              setFieldValue("locationId", value.locationId);
                              setFieldValue("systemId", isSystem ? value.systemId || null : null);
                              setAssetInfo(value);
                              // getMeterData(value.id);
                            } else {
                              setFieldValue("assetId", null);
                              setFieldValue("locationId", null);
                              setFieldValue("systemId", null);
                              setAssetInfo({});
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="assetId"
                              placeholder="Search Asset"
                              size="small"
                              // onChange={handleChange}
                              // variant="standard"

                              InputProps={{
                                ...params.InputProps,
                                endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
                              }}
                            />
                          )}
                        >
                          {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                        </Field>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Location
                        </Typography>
                        {/* <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="locationId"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.locationId !== null
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          {locationId.map((id, i) => (
                            <MenuItem key={i} value={id.id}>
                              {id.locationName}
                            </MenuItem>
                          ))}
                        </Field> */}
                        <Field
                          name="locationId"
                          disabled={
                            values.generationType !== generationType.LOCATION &&
                            values.generationType !== generationType.ASSET
                          }
                          value={locationId.find((loc) => loc.id === values.locationId) || null}
                          readOnly={assetInfo.locationId !== undefined && assetInfo.locationId !== null}
                          component={Autocomplete}
                          filterOptions={filterOptions}
                          options={locationId}
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) => (option ? option.code + " - " + option.locationName : "")}
                          onChange={async (event, value) => {
                            if (value !== null) {
                              console.log(value);
                              setFieldValue("locationId", value.id);
                              setFieldValue("assetId", null);
                              setFieldValue("systemId", null);
                              if (values.generationType === generationType.ASSET) {
                                const assetByLocation = masterAPI["assets"].assetByLocation;
                                await axiosPrivate
                                  .get(`${assetByLocation}/${value.id}`)
                                  .then((res) => {
                                    setAssetId(res.data.result);
                                  })
                                  .catch((e) => {
                                    setAssetId([]);
                                    console.log(e);
                                  });
                              }
                              setAssetInfo({});
                            } else {
                              setFieldValue("locationId", null);
                              setFieldValue("assetId", null);
                              setAssetInfo({});
                              if (values.generationType === generationType.ASSET) {
                                getGenerationData(generationType.ASSET);
                              }
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="locationId"
                              placeholder="Search Location"
                              size="small"
                              onChange={handleChange}
                              // variant="standard"

                              InputProps={{
                                ...params.InputProps,
                                endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
                              }}
                            />
                          )}
                        >
                          {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                        </Field>
                        <ErrorMessage name="locationId">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
                      </Grid>

                      {isSystem && (
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            System
                          </Typography>
                          <Field
                            name="systemId"
                            disabled={
                              values.generationType !== generationType.SYSTEM &&
                              values.generationType !== generationType.ASSET
                            }
                            value={systemId.find((sys) => sys.id === values.systemId) || null}
                            readOnly={assetInfo.systemId !== undefined && assetInfo.systemId !== null}
                            component={Autocomplete}
                            filterOptions={filterOptions}
                            options={systemId}
                            PaperComponent={CustomPaper}
                            getOptionLabel={(option) => (option ? option.systemCode + " - " + option.systemName : "")}
                            onChange={async (event, value) => {
                              if (value !== null) {
                                console.log(value);
                                setFieldValue("systemId", value.id);
                                setFieldValue("assetId", null);
                                setFieldValue("locationId", null);
                                if (values.generationType === generationType.ASSET) {
                                  const assetBySystem = masterAPI["assets"].assetBySystem;
                                  await axiosPrivate
                                    .get(`${assetBySystem}/${value.id}`)
                                    .then((res) => {
                                      setAssetId(res.data.result);
                                    })
                                    .catch((e) => {
                                      setAssetId([]);
                                      console.log(e);
                                    });
                                }
                                setAssetInfo({});
                              } else {
                                setFieldValue("systemId", null);
                                setFieldValue("assetId", null);
                                setAssetInfo({});
                                if (values.generationType === generationType.ASSET) {
                                  getGenerationData(generationType.ASSET);
                                }
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="systemId"
                                placeholder="Search System"
                                size="small"
                                onChange={handleChange}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
                                }}
                              />
                            )}
                          />
                        </Grid>
                      )}

                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Site
                        </Typography>
                        <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="siteId"
                          fullWidth
                          displayEmpty
                          readOnly
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.siteId !== null
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          <MenuItem value={`${siteInfoDetail.siteId}`}>{siteInfoDetail.siteName}</MenuItem>
                        </Field>
                      </Grid>
                      {/* <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          PM Status
                        </Typography>
                        <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="status"
                          fullWidth
                          displayEmpty
                          readOnly={!edit}
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.status !== ""
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          {PMStatus.map((id, i) => (
                            <MenuItem key={i} value={id.value}>
                              {id.text}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid> */}
                      {/* <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Job Type
                        </Typography>
                        <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="workTypeId"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.workTypeId !== null
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          {jobType.map((id, i) => (
                            <MenuItem
                              key={i}
                              value={id.value}
                              disabled={id.text !== "PM"}
                            >
                              {id.text}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid> */}
                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Job Priority
                        </Typography>
                        <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="priorityId"
                          // value={defaultPri}
                          // value={"31e96f8a-61b0-43c0-8b7d-52910040450d"}
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          onChange={(e, v) => {
                            setFieldValue("priorityId", e.target.value);
                            // setDefaultPri(e.target.value);
                          }}
                          renderValue={
                            values.priorityId !== ""
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          {priority.map((id, i) => (
                            <MenuItem key={i} value={id.id}>
                              {id.code + " - " + id.priorityName}
                            </MenuItem>
                          ))}
                        </Field>
                        <ErrorMessage name="priorityId">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Job Type
                        </Typography>
                        <Field
                          as={Select}
                          size={"small"}
                          type="text"
                          name="workTypeId"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.workTypeId !== ""
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          {jobType.map((id, i) => (
                            <MenuItem key={i} value={id.value}>
                              {id.text}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Job Plan
                        </Typography>
                        {/* <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="jobPlanId"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.jobPlanId !== null
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          {jobPlan.map((id, i) => (
                            <MenuItem key={i} value={id.id}>
                              {id.jobPlanName}
                            </MenuItem>
                          ))}
                        </Field> */}
                        <Field
                          name="jobPlanId"
                          //  value={autoValue}
                          // value={values.assetName.code+"_"+values.assetName.assetName}
                          // value={value}
                          inputValue={aCValue.jobplan}
                          component={Autocomplete}
                          filterOptions={filterOptions}
                          loading={jobPlan.length === 0}
                          options={jobPlan}
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) => option.code + " - " + option.jobPlanName || option}
                          freeSolo
                          onChange={(event, value) => {
                            if (value !== null) {
                              console.log(value);
                              setFieldValue("jobPlanId", value.id);
                              setACValue({
                                ...aCValue,
                                jobplan: value.code + " - " + value.jobPlanName,
                              });
                              setFieldValue("jobplanNameText", value.jobPlanName);
                            } else {
                              setFieldValue("jobPlanId", null);
                              setACValue({ ...aCValue, jobplan: "" });
                              setFieldValue("jobplanNameText", "");
                            }
                          }}
                          onInputChange={(e, v) => {
                            setACValue({ ...aCValue, jobplan: v });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="jobPlanId"
                              placeholder="Search JobPlan "
                              size="small"
                              onChange={handleChange}
                              // variant="standard"

                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                    {jobPlan.length === 0 ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        >
                          {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                        </Field>
                        <ErrorMessage name="jobPlanId">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Job Responsible
                        </Typography>
                        <Field
                          name="workCenterId"
                          component={Autocomplete}
                          options={workCenters}
                          getOptionLabel={(option) => option.text || ""}
                          isOptionEqualToValue={(option, value) => option.value === value.value}
                          value={workCenters.find((wc) => wc.value === values.workCenterId) || null}
                          // inputValue={aCValue.workcenter || ""}
                          // onInputChange={(e, v) => {
                          //   setACValue({ ...aCValue, workcenter: v });
                          // }}
                          onChange={(event, value) => {
                            if (value) {
                              setFieldValue("workCenterId", value.value);
                              // setACValue({
                              //   ...aCValue,
                              //   workcenter: value.text,
                              // });
                            } else {
                              setFieldValue("workCenterId", "");
                              // setACValue({ ...aCValue, workcenter: "" });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="workCenterId"
                              placeholder="Search Workcenter"
                              size="small"
                              onChange={handleChange}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {workCenters.length === 0 ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                        <ErrorMessage name="workCenterId">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
                      </Grid>
                      {/* <Grid item xs={12} md={4}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          PM Counter
                        </Typography>
                        <Field
                          as={TextField}
                          size={"small"}
                          type="text"
                          name="woCounter"
                          placeholder="Enter PM Counter"
                          fullWidth
                          sx={{
                            ".MuiInputBase-input": {
                              // letterSpacing: "0.2rem",

                              "&::placeholder": {
                                // color: "green",
                                opacity: 1,
                                color: color.placeholderColor,
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                      </Grid> */}
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value="2" sx={{ p: 1 }}>
                  {/* <CreateGeneral jobPlanIden={handleJobPlanId}/> */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <Grid
                      container
                      sx={{
                        boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                        p: 1.5,
                        backgroundColor: "white",
                      }}
                      alignItems={"center"}
                    >
                      <Grid item xs={12} md={3} lg={2}>
                        <Typography
                          sx={{
                            color: color.masterDialogTitleColor,
                            fontSize: color.masterDialogFontSize,
                            fontWeight: color.sideWeightFont,
                            mb: "10px",
                          }}
                        >
                          Schedule Type
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="scheduleType"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.scheduleType !== ""
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                          onChange={(e) => {
                            console.log(e.target.value);
                            if (e.target.value === "Time") {
                              // setChecked({
                              //   time: true,
                              //   continuous: false,
                              //   gauge: false,
                              // });

                              setFieldValue("pmConditionScheduler.levelIsGivenAs", null);
                              setFieldValue("pmConditionScheduler.resetMeterWhenWorkOrderIsRaised", null);
                              setFieldValue("pmConditionScheduler.resetTo", 0);
                              setFieldValue("pmConditionScheduler.targetDay", 1);
                              setFieldValue("pmConditionScheduler.conditionBaseScheduleEndBy", null);

                              setFieldValue("pmMeterBasedScheduler.meterId", null);
                              setFieldValue("pmMeterBasedScheduler.frequency", 0);
                              setFieldValue("pmMeterBasedScheduler.startAtValue", 0);
                              setFieldValue("pmMeterBasedScheduler.earliestTriggerValue", 0);
                              setFieldValue("pmMeterBasedScheduler.currentReading", 0);
                              setFieldValue("pmMeterBasedScheduler.frequencyUnitForMeter", null);
                              setFieldValue("pmMeterBasedScheduler.triggertype", "Continuous");
                            } else if (e.target.value === "Meter") {
                              if(!values.assetId){
                                toast.error("Please select an asset first");
                                return;
                              }
                              // setChecked({ ...checked, time: false });
                              setFieldValue("pmConditionScheduler.levelIsGivenAs", null);
                              setFieldValue("pmConditionScheduler.resetMeterWhenWorkOrderIsRaised", null);
                              setFieldValue("pmConditionScheduler.resetTo", 0);
                              setFieldValue("pmConditionScheduler.targetDay", 1);
                              setFieldValue("pmConditionScheduler.conditionBaseScheduleEndBy", null);

                              setFieldValue("pmTimeBasedScheduler.frequency", 0);
                              setFieldValue("pmTimeBasedScheduler.frequencyUnitForTime", null);
                              setFieldValue("pmTimeBasedScheduler.nextDueDate", moment().format("YYYY-MM-DDTHH:mm:ss"));
                              setFieldValue(
                                "pmTimeBasedScheduler.targetEndDate",
                                moment().format("YYYY-MM-DDTHH:mm:ss"),
                              );
                              setFieldValue("pmTimeBasedScheduler.offsetDays", 0);
                              setFieldValue("pmTimeBasedScheduler.targetDay", 0);
                              getMeterData(values.assetId);
                            }else if (e.target.value === "Condition") {
                              if(!values.assetId){
                                toast.error("Please select an asset first");
                                return;
                              }
                              setFieldValue("pmTimeBasedScheduler.frequency", 0);
                              setFieldValue("pmTimeBasedScheduler.frequencyUnitForTime", null);
                              setFieldValue("pmTimeBasedScheduler.nextDueDate", moment().format("YYYY-MM-DDTHH:mm:ss"));
                              setFieldValue(
                                "pmTimeBasedScheduler.targetEndDate",
                                moment().format("YYYY-MM-DDTHH:mm:ss"),
                              );
                              setFieldValue("pmTimeBasedScheduler.offsetDays", 0);
                              setFieldValue("pmTimeBasedScheduler.targetDay", 0);

                              setFieldValue("pmMeterBasedScheduler.meterId", null);
                              setFieldValue("pmMeterBasedScheduler.frequency", 0);
                              setFieldValue("pmMeterBasedScheduler.startAtValue", 0);
                              setFieldValue("pmMeterBasedScheduler.earliestTriggerValue", 0);
                              setFieldValue("pmMeterBasedScheduler.currentReading", 0);
                              setFieldValue("pmMeterBasedScheduler.frequencyUnitForMeter", null);
                              setFieldValue("pmMeterBasedScheduler.triggertype", "Continuous");

                              ////Call getGaugeMeterByAsset API to fetch gauge meters for the selected asset
                              getGaugeMeterByAsset(values.assetId);
                            } else if (e.target.value.toUpperCase() === "Mixed") {
                                 if(!values.assetId){
                                toast.error("Please select an asset first");
                                return;
                              }
                              setFieldValue("pmConditionScheduler.levelIsGivenAs", null);
                              setFieldValue("pmConditionScheduler.resetMeterWhenWorkOrderIsRaised", null);
                              setFieldValue("pmConditionScheduler.resetTo", 0);
                              setFieldValue("pmConditionScheduler.targetDay", 1);
                              setFieldValue("pmConditionScheduler.conditionBaseScheduleEndBy", null);

                               getMeterData(values.assetId);
                            }
                            setFieldValue("scheduleType", e.target.value);
                          }}
                        >
                          {scheduleType.map((id, i) => {
                            const isDisabled =
                              ["METER", "MIXED", "CONDITION"].includes((id.value || "").toUpperCase()) &&
                              [generationType.LOCATION, generationType.SYSTEM].includes(values.generationType);

                            return (
                              <MenuItem key={i} value={id.value} disabled={isDisabled}>
                                {id.text}
                              </MenuItem>
                            );
                          })}
                        </Field>
                      </Grid>
                    </Grid>
                        {/* Time Schedule Section */}
                    <Grid
                      container
                      sx={{
                        boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                        p: 1.5,
                        backgroundColor: "white",
                        display:
                          values.scheduleType === "" ||
                          values.scheduleType.toUpperCase() === "TIME" ||
                          values.scheduleType.toUpperCase() === "MIXED" ||
                          values.scheduleType.toUpperCase() === "NONE"
                            ? "default"
                            : "none",
                      }}
                    >
                      <Grid item xs={12}>
                        {/* <Box sx={{display:"flex",alignItems:"center"}}> */}
                        {/* <Checkbox checked={checked.time} disabled={values.scheduleType==="Meter"||values.scheduleType===""} onClick={(e)=>{
                      if(values.scheduleType!=="Time"){

                      
                      if(!e.target.checked){
                        setFieldValue("pmTimeBasedScheduler.frequency",0)
                        setFieldValue("pmTimeBasedScheduler.frequencyUnitForTime",null)
                        setFieldValue("pmTimeBasedScheduler.nextDueDate",moment().format("YYYY-MM-DDTHH:mm:ss"))
                        setFieldValue("pmTimeBasedScheduler.targetEndDate",moment().format("YYYY-MM-DDTHH:mm:ss"))
                        setFieldValue("pmTimeBasedScheduler.offsetDays",0)
                      }
                      handleCheckBox(e,"time")}
                      }/> */}
                        <Typography
                          sx={{
                            color: color.masterDialogTitleColor,
                            fontSize: color.masterDialogFontSize,
                            fontWeight: color.sideWeightFont,
                            mb: "10px",
                          }}
                        >
                          Time Schedule Trigger
                        </Typography>
                        {/* </Box> */}
                        <Divider
                          sx={{
                            border: "1px solid rgb(0 0 0 / 17%)",
                            mb: "15px",
                          }}
                        />
                      </Grid>
                      <Grid container item xs={12} spacing={"1rem"}>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Frequency
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            type="text"
                            name="pmTimeBasedScheduler.frequency"
                            placeholder="Enter Frequency"
                            fullWidth
                            // inputProps={{ readOnly: values.scheduleType.toUpperCase()!=="TIME"||values.scheduleType.toUpperCase()!=="MIXED" }}
                            disabled={
                              values.scheduleType.toUpperCase() === "METER" ||
                              values.scheduleType.toUpperCase() === "" ||
                              values.scheduleType.toUpperCase() === "NONE"
                            }
                            sx={{
                              ".MuiInputBase-input": {
                                // letterSpacing: "0.2rem",

                                "&::placeholder": {
                                  // color: "green",
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                          <ErrorMessage name="pmTimeBasedScheduler.frequency">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Frequency Unit
                          </Typography>

                          <Field
                            as={Select}
                            // label={"Select"}
                            size={"small"}
                            type="text"
                            name="pmTimeBasedScheduler.frequencyUnitForTime"
                            disabled={
                              values.scheduleType.toUpperCase() === "METER" ||
                              values.scheduleType.toUpperCase() === "" ||
                              values.scheduleType.toUpperCase() === "NONE"
                            }
                            fullWidth
                            displayEmpty
                            MenuProps={{
                              PaperProps: { sx: { maxHeight: "40vh" } },
                            }}
                            renderValue={
                              values.pmTimeBasedScheduler.frequencyUnitForTime !== null
                                ? undefined
                                : () => (
                                    <Typography
                                      sx={{
                                        color: color.placeholderColor,
                                        fontSize: "13px",
                                      }}
                                    >
                                      Select
                                    </Typography>
                                  )
                            }
                          >
                            {frequnittime.map((id, i) => (
                              <MenuItem key={i} value={id.value}>
                                {id.text}
                              </MenuItem>
                            ))}
                          </Field>
                          <ErrorMessage name="pmTimeBasedScheduler.frequencyUnitForTime">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Work Duration
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            disabled={
                              values.scheduleType.toUpperCase() === "METER" ||
                              values.scheduleType.toUpperCase() === "" ||
                              values.scheduleType.toUpperCase() === "NONE"
                            }
                            type="text"
                            name="pmTimeBasedScheduler.targetDay"
                            placeholder="Enter Work Duration"
                            fullWidth
                            onChange={(e) => {
                              const workDuration = Number(e.target.value); // Convert input to number
                              setFieldValue("pmTimeBasedScheduler.targetDay", workDuration);

                              if (workDuration > 0 && values.pmTimeBasedScheduler.nextDueDate) {
                                const newNextDueDate = getDateWithOutUTC(values.pmTimeBasedScheduler.nextDueDate).add(
                                  workDuration - 1,
                                  "days",
                                );
                                const offsetDays = Number(values.pmTimeBasedScheduler.offsetDays) || 0;
                                const latestEndDate = getDateWithOutUTC(newNextDueDate);

                                setFieldValue("pmTimeBasedScheduler.targetEndDate", newNextDueDate);

                                setDateValue({
                                  earliestStartDate: getDateWithOutUTC(
                                    values.pmTimeBasedScheduler.nextDueDate,
                                  ).subtract(offsetDays, "days"),
                                  latestEndDate: values.isOffsetDays
                                    ? latestEndDate
                                    : latestEndDate.add(offsetDays, "days"),
                                });
                              } else {
                                setDateValue({
                                  earliestStartDate: null,
                                  latestEndDate: null,
                                });
                              }
                            }}
                            sx={{
                              ".MuiInputBase-input": {
                                "&::placeholder": {
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{
                            ".css-1xhypcz-MuiStack-root": { paddingTop: 0 },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Next Due Date
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DatePicker
                                format="DD/MM/YYYY"
                                value={dayjs(values.pmTimeBasedScheduler.nextDueDate)}
                                //   sx={{".css-1xhypcz-MuiStack-root":{
                                //     padding:0
                                //   }}}
                                disabled={
                                  values.scheduleType.toUpperCase() === "METER" ||
                                  values.scheduleType.toUpperCase() === "" ||
                                  values.scheduleType.toUpperCase() === "NONE"
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    margin: "-8px 0 0 0",
                                    fullWidth: true,
                                  },
                                }}
                                onChange={(newValue) => {
                                  console.log(newValue);
                                  if (newValue !== null) {
                                    if (`${newValue.$d}` !== "Invalid Date") {
                                      const dateFrom = getDateWithOutUTC(newValue);
                                      const endFormat = dateFrom.add(
                                        Number(values.pmTimeBasedScheduler.targetDay) - 1,
                                        "days",
                                      );
                                      const offsetDays = Number(values.pmTimeBasedScheduler.offsetDays) || 0;
                                      const latestEndDate = getDateWithOutUTC(endFormat);

                                      // const hour =
                                      //   new Date().getHours() < 10
                                      //     ? "0" + new Date().getHours()
                                      //     : new Date().getHours();
                                      // const min =
                                      //   new Date().getMinutes() < 10
                                      //     ? "0" + new Date().getMinutes()
                                      //     : new Date().getMinutes();
                                      // const sec =
                                      //   new Date().getSeconds() < 10
                                      //     ? "0" + new Date().getSeconds()
                                      //     : new Date().getSeconds();
                                      // const dateFormat =
                                      //   dateFrom +
                                      //   "T" +
                                      //   hour +
                                      //   ":" +
                                      //   min +
                                      //   ":" +
                                      //   sec;
                                      // const end =
                                      //   endFormat +
                                      //   "T" +
                                      //   hour +
                                      //   ":" +
                                      //   min +
                                      //   ":" +
                                      //   sec;
                                      setFieldValue("pmTimeBasedScheduler.nextDueDate", dateFrom);
                                      setFieldValue("pmTimeBasedScheduler.targetEndDate", endFormat);
                                      setDateValue({
                                        ...dateValue,
                                        earliestStartDate: dateFrom.subtract(
                                          Number(values.pmTimeBasedScheduler.offsetDays),
                                          "days",
                                        ),
                                        latestEndDate: values.isOffsetDays
                                          ? latestEndDate
                                          : latestEndDate.add(offsetDays, "days"),
                                      });
                                    }
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    onBlur={(e) => {
                                      console.log(e, "blur");
                                    }}
                                    // inputRef={datePickerRef}
                                  />
                                )}
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{
                            ".css-1xhypcz-MuiStack-root": { paddingTop: 0 },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Time Schedule End By
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DatePicker
                                format="DD/MM/YYYY"
                                value={
                                  values.pmTimeBasedScheduler.timeBaseScheduleEndBy
                                    ? dayjs(values.pmTimeBasedScheduler.timeBaseScheduleEndBy)
                                    : null
                                }
                                disabled={["METER", "", "NONE"].includes(values.scheduleType.toUpperCase())}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    margin: "-8px 0 0 0",
                                    fullWidth: true,
                                  },
                                }}
                                onChange={(newValue) => {
                                  console.log(newValue);
                                  if (newValue && dayjs(newValue).isValid()) {
                                    setFieldValue(
                                      "pmTimeBasedScheduler.timeBaseScheduleEndBy",
                                      getDateWithOutUTC(newValue),
                                    );
                                  }
                                }}
                              />
                            </DemoItem>
                          </LocalizationProvider>
                          <ErrorMessage name="pmTimeBasedScheduler.timeBaseScheduleEndBy">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            PM Type
                          </Typography>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <FormControlLabel
                              value="Fixed"
                              checked={values.pmType.toUpperCase() === "FIXED"}
                              disabled={
                                values.scheduleType.toUpperCase() === "METER" ||
                                values.scheduleType.toUpperCase() === "" ||
                                values.scheduleType.toUpperCase() === "NONE" ||
                                edit
                              }
                              control={
                                <Radio
                                  onChange={() => {
                                    setFieldValue("pmType", "Fixed");
                                    // setFieldValue("pmType","floating")
                                  }}
                                />
                              }
                              label="Fixed"
                            />
                            <FormControlLabel
                              value="Floating"
                              checked={values.pmType.toUpperCase() === "FLOATING"}
                              disabled={
                                values.scheduleType.toUpperCase() === "METER" ||
                                values.scheduleType.toUpperCase() === "" ||
                                values.scheduleType.toUpperCase() === "NONE" ||
                                edit
                              }
                              control={
                                <Radio
                                  onChange={() => {
                                    setFieldValue("pmType", "Floating");
                                  }}
                                />
                              }
                              label="Floating"
                            />
                          </Box>
                        </Grid>
                        <Grid container item xs={12} md={4} alignItems="flex-end" sx={{ ml: "-12px" }}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={values.isOffsetDays}
                                disabled={
                                  values.scheduleType.toUpperCase() === "METER" ||
                                  values.scheduleType.toUpperCase() === "" ||
                                  values.scheduleType.toUpperCase() === "NONE"
                                }
                                onChange={(event) => {
                                  const isOffsetDays = event.target.checked;
                                  setFieldValue("isOffsetDays", isOffsetDays);
                                  const offsetDays = Number(values.pmTimeBasedScheduler.offsetDays) || 0;
                                  const latestEndDate = getDateWithOutUTC(values.pmTimeBasedScheduler.targetEndDate);
                                  setDateValue({
                                    earliestStartDate:
                                      offsetDays === 0
                                        ? null
                                        : getDateWithOutUTC(values.pmTimeBasedScheduler.nextDueDate).subtract(
                                            offsetDays,
                                            "days",
                                          ),
                                    latestEndDate: isOffsetDays ? latestEndDate : latestEndDate.add(offsetDays, "days"),
                                  });
                                }}
                              />
                            }
                            label="Do not add offset days to latest end date"
                            labelPlacement="top"
                            sx={{
                              alignItems: "flex-start",
                              "& .MuiFormControlLabel-label": {
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Offset Days
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            disabled={
                              values.scheduleType.toUpperCase() === "METER" ||
                              values.scheduleType.toUpperCase() === "" ||
                              values.scheduleType.toUpperCase() === "NONE"
                            }
                            type="text"
                            name="pmTimeBasedScheduler.offsetDays"
                            placeholder="Enter Offset Days"
                            fullWidth
                            onChange={(e) => {
                              const offsetDays = Number(e.target.value) || 0;
                              setFieldValue("pmTimeBasedScheduler.offsetDays", e.target.value);
                              if (offsetDays !== 0) {
                                const latestEndDate = getDateWithOutUTC(values.pmTimeBasedScheduler.targetEndDate);
                                setDateValue({
                                  earliestStartDate: getDateWithOutUTC(
                                    values.pmTimeBasedScheduler.nextDueDate,
                                  ).subtract(offsetDays, "days"),
                                  latestEndDate: values.isOffsetDays
                                    ? latestEndDate
                                    : latestEndDate.add(offsetDays, "days"),
                                });
                              } else {
                                setDateValue({
                                  earliestStartDate: null,
                                  latestEndDate: null,
                                });
                              }
                            }}
                            sx={{
                              ".MuiInputBase-input": {
                                // letterSpacing: "0.2rem",

                                "&::placeholder": {
                                  // color: "green",
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{
                            ".css-1xhypcz-MuiStack-root": { paddingTop: 0 },
                            display:
                              Number(values.pmTimeBasedScheduler.offsetDays) === 0 ||
                              Number(values.pmTimeBasedScheduler.offsetDays) === "" ||
                              Number(values.pmTimeBasedScheduler.offsetDays) === null
                                ? "none"
                                : "default",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              // mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Earliest Start Date
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DatePicker
                                format="DD/MM/YYYY"
                                readOnly
                                value={dateValue.earliestStartDate === null ? null : dayjs(dateValue.earliestStartDate)}
                                //   sx={{".css-1xhypcz-MuiStack-root":{
                                //     padding:0
                                //   }}}
                                disabled={
                                  values.scheduleType.toUpperCase() === "METER" ||
                                  values.scheduleType.toUpperCase() === "" ||
                                  values.scheduleType.toUpperCase() === "NONE"
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    margin: "-8px 0 0 0",
                                    fullWidth: true,
                                  },
                                }}
                                // onChange={(newValue) => {
                                //   console.log(newValue);
                                //   if (newValue !== null) {
                                //     if (`${newValue.$d}` !== "Invalid Date") {
                                //       const dateFrom = moment(
                                //         newValue.$d
                                //       ).format("YYYY-MM-DD");
                                //       const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                //       const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                //       const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                //       const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                //       setFieldValue(
                                //         "pmTimeBasedScheduler.targetEndDate",
                                //       dateFormat
                                //       );
                                //     }
                                //   }
                                // }}
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{
                            ".css-1xhypcz-MuiStack-root": { paddingTop: 0 },
                            display:
                              Number(values.pmTimeBasedScheduler.offsetDays) === 0 ||
                              Number(values.pmTimeBasedScheduler.offsetDays) === "" ||
                              Number(values.pmTimeBasedScheduler.offsetDays) === null
                                ? "none"
                                : "default",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              // mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Latest End Date
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DatePicker
                                format="DD/MM/YYYY"
                                readOnly
                                value={dateValue.latestEndDate === null ? null : dayjs(dateValue.latestEndDate)}
                                //   sx={{".css-1xhypcz-MuiStack-root":{
                                //     padding:0
                                //   }}}
                                disabled={
                                  values.scheduleType.toUpperCase() === "METER" ||
                                  values.scheduleType.toUpperCase() === "" ||
                                  values.scheduleType.toUpperCase() === "NONE"
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    margin: "-8px 0 0 0",
                                    fullWidth: true,
                                  },
                                }}
                                // onChange={(newValue) => {
                                //   console.log(newValue);
                                //   if (newValue !== null) {
                                //     if (`${newValue.$d}` !== "Invalid Date") {
                                //       const dateFrom = moment(
                                //         newValue.$d
                                //       ).format("YYYY-MM-DD");
                                //       const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                //       const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                //       const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                //       const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                //       setFieldValue(
                                //         "pmTimeBasedScheduler.targetEndDate",
                                //       dateFormat
                                //       );
                                //     }
                                //   }
                                // }}
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{
                            ".css-1xhypcz-MuiStack-root": { paddingTop: 0 },
                            display: "none",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              // mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Target End Date
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DatePicker
                                format="DD/MM/YYYY"
                                value={dayjs(values.pmTimeBasedScheduler.targetEndDate)}
                                //   sx={{".css-1xhypcz-MuiStack-root":{
                                //     padding:0
                                //   }}}
                                disabled={
                                  values.scheduleType.toUpperCase() === "METER" ||
                                  values.scheduleType.toUpperCase() === "" ||
                                  values.scheduleType.toUpperCase() === "NONE"
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    margin: "-8px 0 0 0",
                                    fullWidth: true,
                                  },
                                }}
                                onChange={(newValue) => {
                                  console.log(newValue);
                                  if (newValue !== null) {
                                    if (`${newValue.$d}` !== "Invalid Date") {
                                      const dateFrom = getDateWithOutUTC(newValue);

                                      setFieldValue("pmTimeBasedScheduler.targetEndDate", dateFrom);
                                      setDateValue({
                                        ...dateValue,
                                        //earliestStartDate:moment(newValue.$d).subtract(Number(values.pmTimeBasedScheduler.offsetDays), 'days').format("YYYY-MM-DDTHH:mm:ss"),
                                        latestEndDate: values.isOffsetDays
                                          ? getDateWithOutUTC(newValue)
                                          : getDateWithOutUTC(newValue).add(
                                              Number(values.pmTimeBasedScheduler.offsetDays) || 0,
                                              "days",
                                            ),
                                      });
                                    }
                                  }
                                }}
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* Meter Trigger Section */}
                 
                    <Grid
                      container
                      sx={{
                        boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                        p: 1.5,
                        backgroundColor: "white",
                        display:
                          values.scheduleType === "" ||
                          values.scheduleType.toUpperCase() === "METER" ||
                          values.scheduleType.toUpperCase() === "MIXED" ||
                          values.scheduleType.toUpperCase() === "NONE"
                            ? "default"
                            : "none",
                      }}
                    >
                         {meterLoading? <CircularProgress /> : meterData.length === 0 ? <Typography sx={{ color: "red", mb: "10px" }}>
                        No  meters available for the selected asset.
                      </Typography>:
                      <>
                      <Grid item xs={12}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            sx={{
                              color: color.masterDialogTitleColor,
                              fontSize: color.masterDialogFontSize,
                              fontWeight: color.sideWeightFont,
                              mb: "10px",
                            }}
                          >
                            Continuous Trigger
                          </Typography>
                          {/* <FormControlLabel
                            value="Continuous"
                            checked={
                              values.pmMeterBasedScheduler.triggertype.toUpperCase() ===
                              "CONTINUOUS"
                            }
                            disabled={values.scheduleType===""||values.scheduleType.toUpperCase()==="NONE"||values.scheduleType.toUpperCase()==="TIME"}
                            control={
                              <Radio
                                onChange={(e) => {
                                  // setFieldValue("pmMeterBasedScheduler.meterId",null)
                                  // setFieldValue("pmMeterBasedScheduler.frequency",0)
                                  // setFieldValue("pmMeterBasedScheduler.startAtValue",0)
                                  // setFieldValue("pmMeterBasedScheduler.earliestTriggerValue",0)
                                  // setFieldValue("pmMeterBasedScheduler.currentReading",0)
                                  // setFieldValue("pmMeterBasedScheduler.frequencyUnitForMeter",null)

                                  setFieldValue("pmMeterBasedScheduler.triggertype","Continuous");

                                  // handleCheckBox(e, "continuous");
                                }}
                              />
                            }
                            label={ <Typography
                              sx={{
                                color: color.masterDialogTitleColor,
                                fontSize: color.masterDialogFontSize,
                                fontWeight: color.sideWeightFont,

                              }}
                            >
                            Continuous Trigger
                            </Typography> }
                          /> */}
                          {/* <FormControlLabel
                            value="Gauge"
                            checked={
                              values.pmMeterBasedScheduler.triggertype.toUpperCase() === "GAUGE"
                            }
                            // disabled={true}
                            disabled={values.scheduleType===""||values.scheduleType.toUpperCase()==="NONE"||values.scheduleType.toUpperCase()==="TIME"}
                            control={
                              <Radio
                                onChange={(e) => {
                                  setFieldValue("pmMeterBasedScheduler.meterId",null);
                                  setFieldValue("pmMeterBasedScheduler.frequency",0);
                                  setFieldValue("pmMeterBasedScheduler.startAtValue",0);
                                  setFieldValue("pmMeterBasedScheduler.earliestTriggerValue",0);
                                  setFieldValue("pmMeterBasedScheduler.currentReading",0);
                                  setFieldValue("pmMeterBasedScheduler.frequencyUnitForMeter",null);

                                  setFieldValue("pmMeterBasedScheduler.triggertype","Gauge");

                                  // handleCheckBox(e, "gauge");
                                }}
                              />
                            }
                            label= { <Typography
                            sx={{
                              color: color.masterDialogTitleColor,
                              fontSize: color.masterDialogFontSize,
                              fontWeight: color.sideWeightFont,

                            }}
                          >
                          Gauge Trigger
                          </Typography> }
                          /> */}
                        </Box>

                        <Divider
                          sx={{
                            border: "1px solid rgb(0 0 0 / 17%)",
                            mb: "15px",
                          }}
                        />
                      </Grid>
                      <Grid 
                        container
                        item
                        xs={12}
                        spacing={"1rem"}
                        sx={
                          {
                            //display:values.pmMeterBasedScheduler.triggertype.toUpperCase() ==="CONTINUOUS"? "default": "none",
                          }
                        }
                      >
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Meter
                          </Typography>
                          <Field
                            as={Select}
                            // label={"Select"}
                            size={"small"}
                            type="text"
                            name="pmMeterBasedScheduler.meterId"
                            disabled={
                              values.scheduleType === "" ||
                              values.scheduleType === "None" ||
                              values.scheduleType === "Time" ||
                              values.pmMeterBasedScheduler.triggertype.toUpperCase() === "GAUGE"
                            }
                            fullWidth
                            displayEmpty
                            MenuProps={{
                              PaperProps: { sx: { maxHeight: "40vh" } },
                            }}
                            renderValue={
                              values.pmMeterBasedScheduler.meterId !== null
                                ? undefined
                                : () => (
                                    <Typography
                                      sx={{
                                        color: color.placeholderColor,
                                        fontSize: "13px",
                                      }}
                                    >
                                      Select
                                    </Typography>
                                  )
                            }
                          >
                            {meterData.map((meterId, i) => (
                              <MenuItem key={i} value={meterId.meterId}>
                                {meterId.meterName}
                              </MenuItem>
                            ))}
                          </Field>
                          <ErrorMessage name="pmMeterBasedScheduler.meterId">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>

                        {/* <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Frequency Unit
                          </Typography>
                          <Field
                            as={Select}
                            // label={"Select"}
                            size={"small"}
                            type="text"
                            name="pmMeterBasedScheduler.frequencyUnitForMeter"
                            disabled={
                              values.scheduleType === "" ||
                              values.scheduleType === "None" ||
                              values.scheduleType === "Time" ||
                              values.pmMeterBasedScheduler.triggertype.toUpperCase() ===
                                "GAUGE"
                            }
                            fullWidth
                            displayEmpty
                            MenuProps={{
                              PaperProps: { sx: { maxHeight: "40vh" } },
                            }}
                            renderValue={
                              values.pmMeterBasedScheduler
                                .frequencyUnitForMeter !== null
                                ? undefined
                                : () => (
                                    <Typography
                                      sx={{
                                        color: color.placeholderColor,
                                        fontSize: "13px",
                                      }}
                                    >
                                      Select
                                    </Typography>
                                  )
                            }
                          >
                            {frequnitmeter.map((id, i) => (
                              <MenuItem key={i} value={id.value}>
                                {id.text}
                              </MenuItem>
                            ))}
                          </Field>
                        </Grid> */}
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Frequency
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            type="text"
                            name="pmMeterBasedScheduler.frequency"
                            placeholder="Enter Frequency"
                            fullWidth
                            onBlur={(e) => {
                              console.log(e.target.value, "blured");
                              setFieldValue("pmMeterBasedScheduler.startAtValue", e.target.value);
                            }}
                            disabled={
                              values.scheduleType === "" ||
                              values.scheduleType === "None" ||
                              values.scheduleType === "Time" ||
                              values.pmMeterBasedScheduler.triggertype.toUpperCase() === "GAUGE"
                            }
                            sx={{
                              ".MuiInputBase-input": {
                                // letterSpacing: "0.2rem",

                                "&::placeholder": {
                                  // color: "green",
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                          <ErrorMessage name="pmMeterBasedScheduler.frequency">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Frequency Unit
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            type="text"
                            InputProps={{
                              readOnly: true,
                            }}
                            value={
                              meterData.find((meter) => meter.meterId === values.pmMeterBasedScheduler.meterId)
                                ?.uomName || "N/A"
                            }
                            placeholder="Enter Description"
                            fullWidth
                            sx={{
                              ".MuiInputBase-input": {
                                // letterSpacing: "0.2rem",
                                backgroundColor: color.TableCancelButton,
                                "&::placeholder": {
                                  // color: "green",
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />

                          {/* <Field
                            as={Select}
                            size="small"
                            type="text"
                            name="pmMeterBasedScheduler.frequencyUnitForMeter"
                            disabled
                            fullWidth
                            displayEmpty
                            MenuProps={{
                              PaperProps: { sx: { maxHeight: "40vh" } },
                            }}
                            sx={{
                              display: values.pmMeterBasedScheduler.meterId
                                ? "none"
                                : "block",
                            }}
                            renderValue={() => (
                              <Typography
                                sx={{
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                }}
                              >
                                Select
                              </Typography>
                            )}
                          >
                            {meterData.map((id, i) => (
                              <MenuItem key={i} value={id.id}>
                                {id.uomName}
                              </MenuItem>
                            ))}
                          </Field>
                          <ErrorMessage name="pmMeterBasedScheduler.frequencyUnitForMeter">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage> */}
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            StartAt
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            // value={"pmMeterBasedScheduler.startAtValue"}
                            type="text"
                            name="pmMeterBasedScheduler.startAtValue"
                            placeholder="Enter Start Value"
                            fullWidth
                            disabled={
                              values.scheduleType === "" ||
                              values.scheduleType === "None" ||
                              values.scheduleType === "Time" ||
                              values.pmMeterBasedScheduler.triggertype.toUpperCase() === "GAUGE"
                            }
                            sx={{
                              ".MuiInputBase-input": {
                                // letterSpacing: "0.2rem",

                                "&::placeholder": {
                                  // color: "green",
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                          <ErrorMessage name="pmMeterBasedScheduler.startAtValue">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Earliest Trigger
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            type="text"
                            name="pmMeterBasedScheduler.earliestTriggerValue"
                            placeholder="Enter Earliest Trigger Value"
                            fullWidth
                            disabled={
                              values.scheduleType === "" ||
                              values.scheduleType === "None" ||
                              values.scheduleType === "Time" ||
                              values.pmMeterBasedScheduler.triggertype.toUpperCase() === "GAUGE"
                            }
                            sx={{
                              ".MuiInputBase-input": {
                                // letterSpacing: "0.2rem",

                                "&::placeholder": {
                                  // color: "green",
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Meter Schedule End By
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            type="text"
                            name="pmMeterBasedScheduler.meterBaseScheduleEndByValue"
                            placeholder="Enter Meter Schedule End By Value"
                            fullWidth
                            disabled={
                              values.scheduleType === "" ||
                              values.scheduleType === "None" ||
                              values.scheduleType === "Time" ||
                              values.pmMeterBasedScheduler.triggertype.toUpperCase() === "GAUGE"
                            }
                            sx={{
                              ".MuiInputBase-input": {
                                // letterSpacing: "0.2rem",

                                "&::placeholder": {
                                  // color: "green",
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                          <ErrorMessage name="pmMeterBasedScheduler.meterBaseScheduleEndByValue">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>

                        {/* <Grid container item xs={12} md={4} alignItems={"flex-end"} >

                                <FormControlLabel value="Fixed" checked={values.pmType==="fixed"}
                                control={<Radio
                                onChange={()=>{
                                  setFieldValue("pmType","fixed")

                                }}
                                />}
                                label="Fixed" />
                                <FormControlLabel value="Floating" checked={values.pmType==="floating"}
                                control={<Radio
                                  onChange={()=>{
                                    setFieldValue("pmType","floating")

                                  }}
                                  />}
                                label="Floating" />

                                </Grid> */}
                      </Grid>
                      </>
}

                     </Grid>

                    {/* Condition Trigger Section */}
                   
                    <Grid
                      container
                      sx={{
                        boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                        p: 1.5,
                        backgroundColor: "white",
                        display:
                          values.scheduleType.toUpperCase() === "CONDITION" 
                            ? "default"
                            : "none",
                      }}
                    >
                      {conditionMeterLoading ? (
                     <CircularProgress />
                   ) : (gaugeMeters.length === 0 ) ? (
                      <Typography sx={{ color: "red", mb: "10px" }}>
                        No gauge meters available for the selected asset.
                      </Typography>
                    ):
                    <>
                    
                      <Grid item xs={12}>
                        <Typography
                          sx={{
                            color: color.masterDialogTitleColor,
                            fontSize: color.masterDialogFontSize,
                            fontWeight: color.sideWeightFont,
                            mb: "10px",
                          }}
                        >
                          Condition Trigger
                        </Typography>
                        {/* </Box> */}
                        <Divider
                          sx={{
                            border: "1px solid rgb(0 0 0 / 17%)",
                            mb: "15px",
                          }}
                        />
                      </Grid>
                      <Grid container item xs={12} spacing={"1rem"}>

                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Meter to watch
                          </Typography>
                         <Field
                          name="pmConditionScheduler.meterId"
                          value={gaugeMeters.find((a) => a.meterId === values.pmConditionScheduler.meterId) || null}
                          component={Autocomplete}
                          filterOptions={filterOptions}
                          options={gaugeMeters}
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) => (option ? option.meterCode + " - " + option.meterName : "")}
                          onChange={(event, value) => {
                            if (value !== null) {
                              // console.log(value);
                              setFieldValue("pmConditionScheduler.meterId", value.meterId);
                              setGaugeMeterRangeValue(value.alarmAbove);
                            } else {
                              setFieldValue("pmConditionScheduler.meterId", null);
                              setGaugeMeterRangeValue(0);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="pmConditionScheduler.meterId"
                              placeholder="Search Meter"
                              size="small"
                              // onChange={handleChange}
                              // variant="standard" 

                              InputProps={{
                                ...params.InputProps,
                                endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
                              }}
                            />
                          )}
                        >
                          {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                        </Field>
                          <ErrorMessage name="pmConditionScheduler.meterId">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>
                        
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Level is given as
                          </Typography>

                          <Field
                            as={Select}
                            // label={"Select"}
                            size={"small"}
                            type="text"
                            name="pmConditionScheduler.levelIsGivenAs"
                            fullWidth
                            displayEmpty
                            MenuProps={{
                              PaperProps: { sx: { maxHeight: "40vh" } },
                            }}
                            renderValue={
                              values.pmConditionScheduler.levelIsGivenAs !== null
                                ? undefined
                                : () => (
                                    <Typography
                                      sx={{
                                        color: color.placeholderColor,
                                        fontSize: "13px",
                                      }}
                                    >
                                      Select
                                    </Typography>
                                  )
                            }
                          >
                            {conditionGivenAs.map((id, i) => (
                              <MenuItem key={i} value={id.value}>
                                {id.text}
                              </MenuItem>
                            ))}
                          </Field>
                          <ErrorMessage name="pmConditionScheduler.levelIsGivenAs">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Raise the work order when the reading reaches
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            type="text"
                            value={gaugeMeterRangeValue}
                            fullWidth
                             InputProps={{
                              readOnly: true,
                            }}
                            sx={{
                              ".MuiInputBase-input": {
                                backgroundColor: color.TableCancelButton,
                                "&::placeholder": {
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                           Reset the meter when the work order is raised
                          </Typography>

                          <Field
                            as={Select}
                            // label={"Select"}
                            size={"small"}
                            type="text"
                            name="pmConditionScheduler.resetMeterWhenWorkOrderIsRaised"
                            fullWidth
                            displayEmpty
                            MenuProps={{
                              PaperProps: { sx: { maxHeight: "40vh" } },
                            }}
                            renderValue={
                              values.pmConditionScheduler.resetMeterWhenWorkOrderIsRaised !== null
                                ? undefined
                                : () => (
                                    <Typography
                                      sx={{
                                        color: color.placeholderColor,
                                        fontSize: "13px",
                                      }}
                                    >
                                      Select
                                    </Typography>
                                  )
                            }
                          >
                            {[{ value: true, text: "Yes" }, { value: false, text: "No" }].map((id, i) => (
                              <MenuItem key={i} value={id.value}>
                                {id.text}
                              </MenuItem>
                            ))}
                          </Field>
                          <ErrorMessage name="pmConditionScheduler.resetMeterWhenWorkOrderIsRaised">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>
                        {values.pmConditionScheduler.resetMeterWhenWorkOrderIsRaised && (
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Reset to
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            type="number"
                            name="pmConditionScheduler.resetTo"
                            placeholder="Enter work duration"
                            fullWidth
                            onChange={(e) => {
                              setFieldValue("pmConditionScheduler.resetTo", e.target.value);
                            }}
                            sx={{
                              ".MuiInputBase-input": {
                                // letterSpacing: "0.2rem",

                                "&::placeholder": {
                                  // color: "green",
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                        </Grid>
                        )} 
                        <Grid item xs={12} md={4}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Work duration
                          </Typography>
                          <Field
                            as={TextField}
                            size={"small"}
                            type="number"
                            name="pmConditionScheduler.targetDay"
                            placeholder="Enter work duration"
                            fullWidth
                            onChange={(e) => {
                              setFieldValue("pmConditionScheduler.targetDay", e.target.value);
                            }}
                            sx={{
                              ".MuiInputBase-input": {
                                // letterSpacing: "0.2rem",

                                "&::placeholder": {
                                  // color: "green",
                                  opacity: 1,
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                },
                              },
                            }}
                          />
                        </Grid>
                        
                        <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{
                            ".css-1xhypcz-MuiStack-root": { paddingTop: 0 },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                             Schedule End By
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DatePicker
                                format="DD/MM/YYYY"
                                value={
                                  values.pmConditionScheduler.conditionBaseScheduleEndBy 
                                    ? dayjs(values.pmConditionScheduler.conditionBaseScheduleEndBy)
                                    : null
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    margin: "-8px 0 0 0",
                                    fullWidth: true,
                                  },
                                }}
                                onChange={(newValue) => {
                                  console.log(newValue);
                                  if (newValue && dayjs(newValue).isValid()) {
                                    setFieldValue(
                                      "pmConditionScheduler.conditionBaseScheduleEndBy",
                                      getDateWithOutUTC(newValue),
                                    );
                                  }
                                }}
                              />
                            </DemoItem>
                          </LocalizationProvider>
                          <ErrorMessage name="pmConditionScheduler.conditionBaseScheduleEndBy">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        </Grid>
                       
                      </Grid>
                      </>
}
                    </Grid>
                   
                  </Box>
                </TabPanel>
                {!edit && (
                  <TabPanel value="3" sx={{ p: 1 }}>
                    <Grid
                      container
                      sx={{
                        boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                        p: 1.5,
                        backgroundColor: "white",
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: "10px",
                        }}
                      >
                        <Typography
                          sx={{
                            color: color.masterDialogTitleColor,
                            fontSize: color.masterDialogFontSize,
                            fontWeight: color.sideWeightFont,
                          }}
                        >
                          Documents
                        </Typography>
                        <Button variant="contained" onClick={() => setDocDialogOpen(true)}>
                          <UploadFileRounded />
                          File Upload
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider
                          sx={{
                            border: "1px solid rgb(0 0 0 / 17%)",
                            mb: "15px",
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <NormalTable
                          columns={[
                            { Header: "Doc Name", accessor: "documentName" },
                            { Header: "Doc Type", accessor: "documenttype" },
                            {
                              Header: "Actions",
                              Cell: ({ cell }) => (
                                <IconButton
                                  onClick={() => {
                                    setFieldValue(
                                      "documents",
                                      values.documents.filter((_, idx) => idx !== cell.row.index),
                                    );
                                  }}
                                >
                                  <DeleteOutline
                                    sx={{
                                      fontSize: color.masterEditDelButton,
                                      color: color.masterEditDelButtonColor,
                                    }}
                                  />
                                </IconButton>
                              ),
                            },
                          ]}
                          data={values.documents}
                        />
                      </Grid>
                    </Grid>
                    <ResponsiveDialog
                      open={docDialogOpen}
                      onClose={() => setDocDialogOpen(false)}
                      fullWidth
                      maxWidth={"xs"}
                      children={
                        <DocUpload
                          handleCloseClick={() => setDocDialogOpen(false)}
                          handleUpload={(value) => {
                            setFieldValue("documents", [...values.documents, value]);
                            setDocDialogOpen(false);
                          }}
                        />
                      }
                    />
                  </TabPanel>
                )}
              </Box>
            </TabContext>
            <ResponsiveDialog
              open={confirmDialog.open}
              onClose={() => setConfirmDialog({ open: false, message: "", onConfirm: null })}
              fullWidth
              maxWidth="xs"
            >
              <DialogTitle>Confirm Generation Type Change</DialogTitle>
              <DialogContent>
                <DialogContentText>{confirmDialog.message}</DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() =>
                    setConfirmDialog({
                      open: false,
                      message: "",
                      onConfirm: null,
                    })
                  }
                  color="inherit"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    confirmDialog.onConfirm?.();
                    setConfirmDialog({
                      open: false,
                      message: "",
                      onConfirm: null,
                    });
                  }}
                  variant="contained"
                  color="primary"
                >
                  Continue
                </Button>
              </DialogActions>
            </ResponsiveDialog>
            <Grid container item xs={11.9} justifyContent={"flex-end"} gap="1rem">
              <Button
                onClick={handleCancel}
                variant="contained"
                sx={{
                  backgroundColor: color.TableCancelButton,
                  textTransform: "none",
                  color: color.CancelTextColor,
                  ":hover": {
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                type={"submit"}
                variant="contained"
                disabled={loading}
                sx={{
                  textTransform: "none",
                  backgroundColor: loading ? "default" : color.TableButtonColor,
                  "&:hover": {
                    backgroundColor: loading ? "default" : color.buttonDisable,
                  },
                }}
              >
                Submit
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default CreatePM;
